// extracted by mini-css-extract-plugin
module.exports = {"spacing":"ContentList_spacing__bZG-G"};